import React from 'react';

class PagePositionLabel extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      pagesize: this.props.pagesize === undefined ? 0 : this.props.pagesize,
      pagestart: this.props.pagestart === undefined ? 0 : this.props.pagestart,
      pageend: this.props.pageend === undefined ? 0 : this.props.pageend,
      pagetotal: this.props.pagetotal === undefined ? 0 : this.props.pagetotal,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      pagestart: nextProps.pagestart === undefined ? 0 : nextProps.pagestart,
      pageend: nextProps.pageend === undefined ? 0 : nextProps.pageend,
      pagetotal: nextProps.pagetotal === undefined ? 0 : nextProps.pagetotal
    } );
  }

  render( ) {
    if( this.state.hasError === false ) {
      const pagetotal = this.state.pagetotal;
      const pagesize = this.state.pagesize;
      const recordstring = pagetotal > 1 ? 'records' : 'record';

      if( pagetotal < pagesize ) {
        return (
          <span className="page-position-label" >Showing {this.state.pagetotal} {recordstring}</span>
        );
      } else {
        return (
          <span className="page-position-label">
            Showing {this.state.pagestart} to {this.state.pageend} of {this.state.pagetotal} {recordstring}
          </span>
        );
      }
    } else {
      return ( <span></span> );
    }
  }
}

export default PagePositionLabel;



// WEBPACK FOOTER //
// ./src/presentation/PagePositionLabel.js